<div>
    <hub-modal-header headerText="{{ 'bikeshop.workshop.jobcard.custom_questions' | translate }}"
        [activeModal]="activeModal"></hub-modal-header>
</div>

<div class="modal-content-container" [ngClass]="{'jobcard-locked': jobcard.statusID == 50}">

    <div class="custom-questions-container">
        <div *ngFor="let customQuestionGroup of jobcard.customQuestions">
            
            <div class="group-header">{{customQuestionGroup.groupName}} - {{customQuestionGroup.serviceType}}</div>

            <div *ngFor="let customQuestion of customQuestionGroup.customQuestions" class="custom-question-control">
                <div *ngIf="customQuestion.controlType === 'TEXTINPUT'">
                    <hub-input 
                        [label]="customQuestion.question"                        
                        [required]="customQuestion.mandatory"
                        [placeholder]="customQuestion.hint" 
                        [(ngModel)]="customQuestion.response"></hub-input>
                </div>
                <div *ngIf="customQuestion.controlType === 'TEXTAREA'">
                    <hub-text-area 
                        [rows]="3" 
                        [label]="customQuestion.question"
                        [required]="customQuestion.mandatory"
                        [placeholder]="customQuestion.hint" 
                        [(ngModel)]="customQuestion.response"></hub-text-area>
                </div>
                <div *ngIf="customQuestion.controlType === 'CHECKBOX'">
                    <hub-checkbox 
                        [label]="customQuestion.question"
                        [labelExtra]="customQuestion.hint"
                        [(ngModel)]="customQuestion.response"></hub-checkbox>
                </div>
            </div>

        </div>
    </div>
</div>
<div class="modal-footer-container">
    <div *ngIf="!isvalid()" class="error-message">
        {{'general.complete_mandatory_fields' | translate }}
    </div>
    <div class="button-container">        
        <hub-button *ngIf="jobcard.id" [text]="'bikeshop.thirdparty.add_edit.action.save' | translate" [disabled]="!isvalid() || updating" [loading]="updating" (buttonClick)="save()" [style]="'secondary'" [size]="'xl'"></hub-button>
        <hub-button *ngIf="!jobcard.id" [text]="'onboarding.button.done' | translate" [disabled]="!isvalid()" (buttonClick)="done()" [style]="'secondary'" [size]="'xl'"></hub-button>
    </div>
    <div class="short-cut-container">
        <!-- <div>
            {{'bikeshop.workshop.jobcard.quote.to_navigate' | translate}}
        </div> -->
        <div>
            <span><daz-icon [name]="'enter'" [size]="'18px'"
                    [color]="'#6B728C'"></daz-icon></span>{{'bikeshop.workshop.jobcard.quote.to_save_and_close' |
            translate}}
        </div>
    </div>
</div>
